import { render, staticRenderFns } from "./ContestRibbon.vue?vue&type=template&id=2d53a6d6&scoped=true&"
import script from "./ContestRibbon.vue?vue&type=script&lang=js&"
export * from "./ContestRibbon.vue?vue&type=script&lang=js&"
import style0 from "./ContestRibbon.vue?vue&type=style&index=0&id=2d53a6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d53a6d6",
  null
  
)

export default component.exports